import { c as _c } from "react/compiler-runtime";
import { CountDownTimerPropertiesType } from "@website/ui/count-down-timer/count-down-timer.types";
import { numberConvert } from "@website/utils/number-convert";
import { useEffect, useRef } from "react";
export const useCountDownTimer = properties => {
  const $ = _c(6);
  const {
    seconds,
    onTimerEnd
  } = properties;
  const remainingSeconds = useRef(seconds);
  const containerReference = useRef(null);
  let t0;
  if ($[0] !== onTimerEnd) {
    t0 = () => {
      let intervalId = -1;
      const makeTimeText = () => {
        const minutes = Math.floor(remainingSeconds.current / 60);
        const seconds_0 = remainingSeconds.current - minutes * 60;
        return numberConvert(`${minutes.toString().padStart(2, "0")}:${seconds_0.toString().padStart(2, "0")}`, {
          numberOnly: false,
          locale: "fa"
        });
      };
      if (typeof window !== "undefined") {
        if (remainingSeconds.current > 0 && containerReference.current) {
          containerReference.current.innerHTML = makeTimeText();
        }
        intervalId = window.setInterval(() => {
          if (remainingSeconds.current > 0) {
            if (containerReference.current) {
              remainingSeconds.current = remainingSeconds.current - 1;
              containerReference.current.innerHTML = makeTimeText();
            }
          } else {
            clearInterval(intervalId);
            onTimerEnd?.();
          }
        }, 1000);
      }
      return () => {
        clearInterval(intervalId);
      };
    };
    $[0] = onTimerEnd;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== onTimerEnd || $[3] !== seconds) {
    t1 = [onTimerEnd, seconds];
    $[2] = onTimerEnd;
    $[3] = seconds;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      containerReference
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};